import messageResource from '../../messageResource'

export const getDeletedTasksToastText = (deletedTaskIds, task) => {
    if (deletedTaskIds.length === 0) {
        return messageResource.getMessage("delete.tasks.toast.none")
    }

    if (deletedTaskIds.length === 1 && task) {
        return messageResource.getMessage("delete.tasks.toast.singular", [task.name])
    }

    if (deletedTaskIds.length === 1) {
        return messageResource.getMessage("delete.unknown_task.toast");
    }

    return messageResource.getMessage("delete.tasks.toast", [deletedTaskIds.length])
}


export const getAssignedTaskToastText = (tasksCount, usersCount, task) => {
    if (tasksCount === 0 || usersCount === 0) {
        return messageResource.getMessage("assign_to.tasks.toast.none")
    }

    if (tasksCount === 1 && usersCount === 1) {
        return messageResource.getMessage("assign_to.tasks.toast.one_task_one_user", [task.name])
    }

    if (tasksCount === 1 && usersCount > 1) {
        return messageResource.getMessage("assign_to.tasks.toast.one_task", [task.name, usersCount])
    }

    if (tasksCount > 1 && usersCount === 1) {
        return messageResource.getMessage("assign_to.tasks.toast.one_user", [tasksCount])
    }

    return messageResource.getMessage("assign_to.tasks.toast", [tasksCount, usersCount])
}

export const getStatusChangedTaskToastText = (taskCount, task) => {
    if (taskCount === 0) {
        return messageResource.getMessage("status.tasks.toast.none")
    }

    if (taskCount === 1) {
        return messageResource.getMessage("status.tasks.toast.singular", [task.name])
    }

    return messageResource.getMessage("status.tasks.toast", [taskCount])
}

export const getMoveTasksToastText = (tasksCount, project, task) => {
    if (tasksCount === 1) {
        return messageResource.getMessage('move.task.toast', [task.name, project.name])
    }

    return messageResource.getMessage("move.tasks.toast", [tasksCount, project.name])
}

export const getCopyTasksToastText = (tasksCount, project, task) => {
    if (tasksCount === 1) {
        return messageResource.getMessage('copy.task.toast', [task.name, project.name])
    }

    return messageResource.getMessage("copy.tasks.toast", [tasksCount, project.name])
}



// WEBPACK FOOTER //
// ./web/js/taskManagement/bulkOperations/utils.js